module.exports = __webpack_public_path__ + "static/media/tipo4.6b3e052a.png";